var map = {
	"./en/Auth.json": 67085,
	"./en/Common.json": 25594,
	"./en/LeftNav.json": 4343,
	"./en/TicketCreate.json": 26351,
	"./en/TicketDetail.json": 6162,
	"./en/TicketList.json": 39079,
	"./en/TicketTools.json": 35514,
	"./zh-CN/Auth.json": 85582,
	"./zh-CN/LeftNav.json": 17350,
	"./zh-CN/TicketCreate.json": 22276,
	"./zh-CN/TicketDetail.json": 99045,
	"./zh-CN/TicketList.json": 10936,
	"./zh-CN/TicketTools.json": 68851,
	"./zh-CN/common.json": 20289
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21326;